import React from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "@lib/types/Context";
import { SharedPaymentHistory } from "@app/shared";

const CustomerPaymentHistories: React.FC = () => {
  const { customerId } = useParams();

  // Check if user has permission to view wallet pool
  // if (!permissions.canViewWalletPool) {
  //   return <NoPermission />;
  // }

  return (
    <SharedPaymentHistory
      context={AppContext.CUSTOMER}
      customerId={customerId}
    />
  );
};

export default CustomerPaymentHistories;
